import { createSelector } from '@reduxjs/toolkit';

export const selectSuccessState = (state: any) => state.success;

export const selectSuccess = createSelector(
  [selectSuccessState],
  (success) => success.success
);
